<template>
    <div>
        <div v-if="flight.length && flight[0].length"
             :class="['flight-block block',{ show }]">

            <!--Блок разварачивания-->
            <div @click="blockToggle()"
                 class="block-toggle-bar align-center justify-between">
                <div class="block-name align-center justify-center">
                    <icon name="flight" width="20px" height="21px" fill="rgba(255,255,255,0.7)" />
                    <span class="ml-8">{{ localizeList.flight }}</span>
                </div>
                <icon name="angle" width="12px" height="8px" fill="var(--white-color)" class="angle-icon" />
            </div>
            <div v-if="show && flight.length"
                 class="flight-info-wrap">
                <div class="flight-info-header align-center justify-between">
                    <div class="align-center">
                        <h3 class="flight-path">{{ flightPath }}</h3>
                        <p class="dark-small-text ml-6">{{getTimeLimitText}}</p>
                    </div>

                    <div class="align-center more-options">
<!--                        <button :style="{'opacity': showResetBtn ? 1 : 0}"-->
                        <button v-show="showResetBtn"
                                @click="resetFlight()"
                                class="change-btn mr-6">
                            {{ localizeList.resetFlightsUpper }}
                        </button>
                        <button :style="{'opacity': showFlightEditBtn ? 1 : 0}"
                                @click="toFlight()"
                                class="change-btn">
                            {{ localizeList.seeМoreОptions }}
                        </button>
                    </div>
                </div>
                <div v-for="(item, key) in flight"
                     :key="key"
                     v-show="showFlight(key)"
                     class="flight-info">
                    <span v-show="item[0].isGDS && item[0].delta || !item[0].isGDS" :style="[{ 'opacity': item[0].delta ? 1 : 0 }]" class="delta">
                        {{ item[0].delta > 0 ? "+" : "" }}{{ correctPrice(item[0].delta) }} {{  getCurrencyDisplayBySettings(tourCardData.tourCurrency) }}
                    </span>
                    <div @click="changeFlight(key)"
                         :class="['flight-group', {'selected':flightData.selected === key}, {'single': flight.length === 1 || toFlightMounted}]">
                        <div v-for="(item2, key2) in getFlight(item)"
                             :key="key2"
                             class="flight-coontent">
                            <div class=" date-avia-info hidden">
                                <div class="date-info mr-10">
                                    <div>
                                        <p class="day-info mr-10 nowrap">
                                            {{ item2.dateFrom }}
                                        </p>
                                        <p v-show="item2.daysCount" class="day-info nowrap">
                                            (+{{ item2.daysCount }})
                                        </p>
                                    </div>
                                    <div class="time-info">
                                        <div class="time nowrap mb-1">
                                            {{ item2.timeFrom }} – {{ item2.timeTo }}
                                        </div>
                                        <div v-show="getTimeDuration(item2)" class="time-diff nowrap">
                                            {{ localizeList.enRoute }} {{ getTimeDuration(item2) }}
                                        </div>
                                    </div>
                                    <div @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(item2.airlinesTitle, $event, true)"
                                         class="airlines-icon ml-8 popover-link">
                                        <img v-for="(item3, key3) in item2.airlineIds"
                                             :key="key3"
                                             :style="[{'left': key3*10 + 'px'}, {'top': key3*4 + 'px'}]"
                                             width="24" height="24"
                                             :src="`${API_ORIGIN}${PATH}/GetImage/GetImage?type=Airline&id=${item3}&width=50&height=50`"/>
                                    </div>
                                </div>
                                <div :class="['avia-info hidden ml-10', {'pl-4': item2.airlineIds.length > 3}]">
                                    <p @mouseleave="hidePopover()"
                                       @mouseenter="showPopover(item2.airlinesTitle, $event, true)"
                                       class="avia-code nowrap ellipsis popover-link mb-2">
                                        {{ item2.airaports }}
                                    </p>
                                    <p class="airline nowrap ellipsis">
                                        {{ getTransits(item2) }}
                                    </p>
                                </div>
                            </div>

                            <div class="align-center">
                                <div class="details-info align-center ml-4 mr-10">
                                    <template v-if="!!item2.remoteFlightId">
                                        <div @mouseleave="hidePopover()"
                                             @mouseenter="showPopover(item2.carryOnAndBaggage.carryOn.info, $event)"
                                             class="mr-4 relative">
                                            <icon name="luggage" width="16px" height="15px"/>
                                            <span class="luggage-text absolute-center">{{item2.carryOnAndBaggage.carryOn.value}}</span>
                                        </div>
                                        <div @mouseleave="hidePopover()"
                                             @mouseenter="showPopover(item2.carryOnAndBaggage.baggage.info, $event)"
                                             class="mr-4 relative">
                                            <icon :name="item2.carryOnAndBaggage.baggageType" width="14px" height="24px"/>
                                            <span class="luggage-text absolute-center">{{item2.carryOnAndBaggage.baggage.value}}</span>
                                        </div>
                                    </template>
                                    <div class="popover-link"
                                         @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(getQuotaText(item2.quota), $event)">
                                        <icon :name="getQuotaName(item2.quota)" fill="var(--white-color)" width="16px" height="16px"/>
                                    </div>
                                    <div class="popover-link ml-6"
                                         @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(getFlightTypeText(item2), $event)">
                                        <icon name="gds" :fill="!!item2.remoteFlightId ? '#1F8B4D' : 'var(--lighten-5-color)'"/>
                                    </div>
                                </div>
                                <flight-class-select :items="item2.flightClass"
                                                     :tour-rate="flight[0][0].parent.Rate"
                                                     :disabled="!!item2.remoteFlightId"
                                                     @click.native="stop()"
                                                     @change="changeFlightClass(key, key2, $event)"
                                                     v-model="item2.flightClassSelectedValue"
                                                     class="flight-class"/>
                            </div>
                        </div>
                    </div>

                    <div class="align-center justify-end mt-4">
                        <!--                    <span class="more-info-link pr-10">-->
                        <!--                        {{ localizeList.tariffConditions }}-->
                        <!--                    </span>-->

                        <span v-if="item[0].isGDS"
                              @click="showDetails(item)"
                              class="more-info-link ml-10">
                        {{ localizeList.flightDetails|capitalize }}
                    </span>
                        <span v-else
                              @click="rightModalAviaFlight(item)"
                              class="more-info-link ml-10">
                        {{ localizeList.flightDetails|capitalize }}
                    </span>
                    </div>

                    <div v-show="universalParametrs.items.length && item[0].timeLimit && flightData.selected === key"
                         :class="['tariff-info mt-4',{'show': tariffBlockShow}]">
                        <!--Блок разварачивания инф. о тарифе-->
                        <div @click="tariffBlockToggle()"
                             class="block-toggle-bar align-center justify-between">
                            <div class="block-name align-center justify-center">
                                <span class="ml-4">{{ localizeList.tarifInformationTitleUpper }}</span>
                            </div>
                            <icon name="angle" width="12px" height="8px" fill="var(--white-color)" class="angle-icon" />
                        </div>
                        <div v-if="tariffBlockShow" class="tariff-info-content">
                            <h5 class="standard-500-text mb-3">
                                {{universalParametrs.tariffName}}
                            </h5>

                            <template v-if="!universalParametrs.loader">
                                <div v-for="(item2, key2) in universalParametrs.items"
                                     :key="key2"
                                     class="align-center mb-3">
                                    <icon v-if="item2.status === 1" name="aviailable" width="14px" height="14px" fill="var(--white-color)" />
                                    <icon v-else-if="item2.status === 2" name="dollar" width="14px" height="14px" fill="var(--yellow-color)" />
                                    <icon v-else name="not-aviailable" width="14px" height="14px" />
                                    <p class="card-text">{{item2.text}}</p>
                                </div>
                            </template>
                            <div v-else class="justify-center">
                                <base-loader size="48" weight="5" />
                            </div>
                        </div>
                    </div>

                    <div v-show="key === 0 && flight.length > 1 && showFlight(key+1)" class="more-suggestions">{{ localizeList.moreSuggestions }}</div>
                </div>
            </div>
        </div>

        <!--Внутренние перелеты-->
        <div v-if="flight.length && subFlights.length"
             :class="['flight-block block',{ show: showSubFlight }]">

            <!--Блок разварачивания-->
            <div @click="showSubFlight = !showSubFlight"
                 class="block-toggle-bar align-center justify-between">
                <div class="block-name align-center justify-center">
                    <icon name="flight" width="20px" height="21px" fill="rgba(255,255,255,0.7)" />
                    <span class="ml-8">{{ localizeList.flight }}</span>
                </div>
                <icon name="angle" width="12px" height="8px" fill="var(--white-color)" class="angle-icon" />
            </div>
            <div v-if="showSubFlight"
                 class="flight-info-wrap">
                <div class="flight-info-header align-center justify-between">
                    <div class="align-center">
                        <h3 class="flight-path">{{ subFlightPath }}</h3>
                    </div>
                </div>
                <div v-for="(item, key) in subFlights"
                     :key="key"
                     class="flight-info">
                    <div class="flight-group">
                        <div v-for="(item2, key2) in getFlight(item)"
                             :key="key2"
                             class="flight-coontent">
                            <div class=" date-avia-info hidden">
                                <div class="date-info mr-10">
                                    <div>
                                        <p class="day-info mr-10 nowrap">
                                            {{ item2.dateFrom }}
                                        </p>
                                        <p v-show="item2.daysCount" class="day-info nowrap">
                                            (+{{ item2.daysCount }})
                                        </p>
                                    </div>
                                    <div class="time-info">
                                        <div class="time nowrap mb-1">
                                            {{ item2.timeFrom }} – {{ item2.timeTo }}
                                        </div>
                                        <div v-show="getTimeDuration(item2)" class="time-diff nowrap">
                                            {{ localizeList.enRoute }} {{ getTimeDuration(item2) }}
                                        </div>
                                    </div>
                                    <div @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(item2.airlinesTitle, $event, true)"
                                         class="airlines-icon ml-8 popover-link">
                                        <img v-for="(item3, key3) in item2.airlineIds"
                                             :key="key3"
                                             :style="[{'left': key3*10 + 'px'}, {'top': key3*4 + 'px'}]"
                                             width="24" height="24"
                                             :src="`${API_ORIGIN}${PATH}/GetImage/GetImage?type=Airline&id=${item3}&width=50&height=50`"/>
                                    </div>
                                </div>
                                <div :class="['avia-info hidden ml-10', {'pl-4': item2.airlineIds.length > 3}]">
                                    <p @mouseleave="hidePopover()"
                                       @mouseenter="showPopover(item2.airlinesTitle, $event, true)"
                                       class="avia-code nowrap ellipsis popover-link mb-2">
                                        {{ item2.airaports }}
                                    </p>
                                    <p class="airline nowrap ellipsis">
                                        {{ getTransits(item2) }}
                                    </p>
                                </div>
                            </div>

                            <div class="align-center">
                                <div class="details-info align-center ml-4 mr-10">
                                    <template v-if="!!item2.remoteFlightId">
                                        <div @mouseleave="hidePopover()"
                                             @mouseenter="showPopover(item2.carryOnAndBaggage.carryOn.info, $event)"
                                             class="mr-4 relative">
                                            <icon name="luggage" width="16px" height="15px"/>
                                            <span class="luggage-text absolute-center">{{item2.carryOnAndBaggage.carryOn.value}}</span>
                                        </div>
                                        <div @mouseleave="hidePopover()"
                                             @mouseenter="showPopover(item2.carryOnAndBaggage.baggage.info, $event)"
                                             class="mr-4 relative">
                                            <icon :name="item2.carryOnAndBaggage.baggageType" width="14px" height="24px"/>
                                            <span class="luggage-text absolute-center">{{item2.carryOnAndBaggage.baggage.value}}</span>
                                        </div>
                                    </template>
                                    <div class="popover-link"
                                         @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(getQuotaText(item2.quota), $event)">
                                        <icon :name="getQuotaName(item2.quota)" fill="var(--white-color)" width="16px" height="16px"/>
                                    </div>
                                    <div class="popover-link ml-6"
                                         @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(getFlightTypeText(item2), $event)">
                                        <icon name="gds" :fill="!!item2.remoteFlightId ? '#1F8B4D' : 'var(--lighten-5-color)'"/>
                                    </div>
                                </div>
                                <flight-class-select :items="item2.flightClass"
                                                     :tour-rate="flight[0][0].parent.Rate"
                                                     :disabled="!!item2.remoteFlightId"
                                                     @click.native="stop()"
                                                     @change="changeFlightClass(key, key2, $event)"
                                                     v-model="item2.flightClassSelectedValue"
                                                     class="flight-class"/>
                            </div>
                        </div>
                    </div>

                    <div class="align-center justify-end mt-4">
                        <!--                    <span class="more-info-link pr-10">-->
                        <!--                        {{ localizeList.tariffConditions }}-->
                        <!--                    </span>-->

                        <span v-if="item[0].isGDS"
                              @click="showDetails(item, true)"
                              class="more-info-link ml-10">
                        {{ localizeList.flightDetails|capitalize }}
                    </span>
                        <span v-else
                              @click="rightModalAviaFlight(item, true)"
                              class="more-info-link ml-10">
                        {{ localizeList.flightDetails|capitalize }}
                    </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { bus } from "../../../main";
    import {getLocalTimeLimit} from "../../../plugins/methods";
    import moment from "moment"
    import FlightClassSelect from "../selects/flightClassSelect";

    export default {
        name: "flight",
        components: {
            FlightClassSelect,
        },
        data() {
            return {
                API_ORIGIN: this.$store.getters['getApiOrigin'],
                PATH: this.$store.getters['getPath'],
                tariffBlockShow: false,
                stopSelect: false,
                automaticFlightSelection: false,
                showSubFlight: true
            }
        },
        props: {
            flight: {
                type: Array,
                default: () => []
            },
            tour: {
                type: Object,
                default: () => {}
            },
            tourists: {
                type: Array,
                default: () => [1,0]
            },
            universalParametrs: {
                type: Object,
                default: () => {}
            },
            flightData: {
                type: Object,
                default: () => {}
            },
            tourCardData: {
                type: Object,
                default: () => {}
            },
            showFlightEditBtn: {
                type: Boolean,
                default: true
            },
            flightChanged: {
                type: Boolean,
                default: true
            },
            toFlightMounted: {
                type: Boolean,
                default: true
            },
            show: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            getTimeLimitText() {
                const item = this.flight[this.flightData.selected];
                const timeLimit = this.getTimeLimit(item);
                if (!timeLimit) return "";
                return this.localizeList.timeLimitTextUpper2 +': '+ timeLimit
            },
            subFlights() {
                return this.getFlight(this.flight[this.flightData.selected], true)
            },
            showResetBtn() {
                return !this.toFlightMounted && this.flightChanged && this.flight[this.flightData.selected][0].isGDS;
            },
            flightPath() {
                // const from = this.flight[0][0].allData.DepartureCity.Value;
                // const fromDirection = this.flight[0][0].direction?.[0] || this.flight[0][0].flightType;
                // const back = this.flight[0][this.flight[0].length - 1].allData.ArrivalCity.Value;
                // let to = '';
                // let isTransplants = true;
                // this.flight[0].forEach((x, i) => {
                //     // if (
                //     //     (!x.direction && x.flightType !== 1 || x.direction && x.direction[i] !== 1)
                //     //     && !to
                //     // ) {
                //     if (
                //         (!x.direction && x.flightType !== fromDirection || x.direction && x.direction[i] !== fromDirection)
                //         && !to
                //     ) {
                //         to = x.allData.DepartureCity.Value;
                //     }
                // });
                // if (!to) {
                //     isTransplants = false;
                //     to = this.flight[0][this.flight[0].length-1].allData.ArrivalCity.Value;
                // }
                //
                // return `${from} – ${to} ${isTransplants ? ' – ' + back : ''}`

                const flights = this.getFlight(this.flight[this.flightData.selected]);
                const from = flights[0].allData.DepartureCity.Value;
                const to = flights[0].allFlights[flights[0].allFlights.length-1].allData.ArrivalCity.Value;
                let isTransplants = false;
                let back = "";

                if (flights.length > 1) {
                    isTransplants = true;
                    back = flights[1].allFlights[flights[1].allFlights.length-1].allData.ArrivalCity.Value;
                }

                return `${from} – ${to} ${isTransplants ? ' – ' + back : ''}`
            },
            subFlightPath() {
                const from = this.subFlights[0][0].allData.DepartureCity.Value;
                let to = this.subFlights.length > 1 ? this.subFlights[this.subFlights.length-1][0].allData.DepartureCity.Value : '';
                let isTransplants = true;
                if (!to) {
                    isTransplants = false;
                    to = this.subFlights[0][this.subFlights[0].length-1].allData.ArrivalCity.Value;
                }

                return `${from} – ${to} ${isTransplants ? ' – ' + from : ''}`
            },
        },
        created() {
            bus.$on("automaticFlightSelection", val => this.automaticFlightSelection = val)
        },
        methods: {
            showFlight(key) {
                return this.toFlightMounted && key === this.flightData.selected || !this.toFlightMounted
            },
            getFlightTypeText(item) {
                return item.remoteFlightId ? this.localizeList.GDSFlight : this.localizeList.operatorFlight
            },
            getTransits(item2) {
                if (!item2.isTransit) return this.localizeList.direct;

                if (item2.transits === 1) return `${this.localizeList.oneDirectUpper}, ${item2.airlines}`;
                else return `${item2.transits} ${this.localizeList.transit}, ${item2.airlines}`
            },
            getFlight(arr, getSubFlights = false, getSimple = false, getSimpleAll = false) {
                let to = [];
                let back = [];
                const flights = [];

                arr.forEach((x) => {
                    // const index = flights.map(x2 => x2[0].flightType).indexOf(x.flightType);
                    // console.log(index, 444,flights.map(x2 => x2[0].flightType),x.flightType,x);
                    // if (!flights.length || index === -1) {
                    //     flights.push([x])
                    // } else {
                    //     flights[index].push(x);
                    // }
                    if (!flights.length || flights[flights.length-1][0].flightType !== x.flightType) {
                        flights.push([x])
                    } else {
                        flights[flights.length-1].push(x);
                    }
                    // if (!flights[x.flightType-1]) {
                    //     flights.push([x])
                    // } else {
                    //     flights[x.flightType-1].push(x);
                    // }
                });
                to = flights[0];
                back = flights.length > 1 ? flights[flights.length - 1] : [];
                const subFlight = flights.slice(1, flights.length - 1);

                if (getSubFlights) {
                    return subFlight
                }

                if (getSimple) {
                    if (back.length) return [to, back];
                    else return [to]
                }

                if (getSimpleAll) {
                    return flights;
                }

                const toIsTransit = to.length > 1;
                const toGroup = {
                    dateFrom: this.getFlightBeginDate(to[0]),
                    daysCount: this.getDaysCount(to[0], to[to.length-1]),
                    // daysCount: toIsTransit ? this.getDaysCount(to[0], to[to.length-1]) : null,
                    timeFrom: to[0].timeFrom,
                    timeTo: to[to.length-1].timeTo,
                    timeDuration: this.getFlightTimeDuration(to),
                    airaports: this.getFlightAiraport([to[0], to[to.length-1]]),
                    isTransit: toIsTransit,
                    transits: to.length-1,
                    airlines: this.getFlightAirlines(to),
                    airlinesTitle: this.getFlightAirlinesTitle(to),
                    airlineIds: this.getFlightAirlineIds(to),
                    quota: this.getFlightQuotaName(to),
                    carryOnAndBaggage: this.getFlightCarryOnAndBaggage(to),
                    flightClass: this.getFlightClass(to),
                    flightClassSelected: this.getFlightClassSelected(to),
                    flightClassSelectedValue: this.getFlightClassSelectedValue(to),
                    allData: to[0].allData,
                    remoteFlightId: !!to[0].remoteFlightId,
                    allFlights: to
                };
                let backGroup = {};
                if (back.length) {
                    const backIsTransit = back.length > 1;
                    backGroup = {
                        dateFrom: this.getFlightBeginDate(back[0]),
                        daysCount: this.getDaysCount(back[0], back[back.length-1]),
                        // daysCount: backIsTransit ? this.getDaysCount(back[0], back[back.length-1]) : null,
                        timeFrom: back[0].timeFrom,
                        timeTo: back[back.length-1].timeTo,
                        timeDuration: this.getFlightTimeDuration(back),
                        airaports: this.getFlightAiraport([back[0], back[back.length-1]]),
                        isTransit: backIsTransit,
                        transits: back.length-1,
                        airlines: this.getFlightAirlines(back),
                        airlinesTitle: this.getFlightAirlinesTitle(back),
                        airlineIds: this.getFlightAirlineIds(back),
                        quota: this.getFlightQuotaName(back),
                        carryOnAndBaggage: this.getFlightCarryOnAndBaggage(back),
                        flightClass: this.getFlightClass(back),
                        flightClassSelected: this.getFlightClassSelected(back),
                        flightClassSelectedValue: this.getFlightClassSelectedValue(back),
                        allData: back[0].allData,
                        remoteFlightId: !!back[0].remoteFlightId,
                        allFlights: back
                    };
                }

                if (back.length) return [toGroup, backGroup];
                else return [toGroup]
            },
            getFlightClass(items) {
                const res = [];
                const notComboTariff = this.tour.LinkingFlightsRules.notCombineDifferentTariffGroupRule.enabled;

                if (notComboTariff) {
                    items = JSON.parse(JSON.stringify(items));
                    let currentCost = 0;

                    items.forEach((x) => {
                        x.flightClass.forEach(x2 => {
                            if (parseInt(x2.secondLabel) === 0) {
                                currentCost += x2.value
                            }
                        });
                    });


                    const getCost = (label) => {
                        let res = 0;
                            items.forEach((x) => {
                                x.flightClass.forEach((x2) => {
                                    if (x2.label === label) res += x2.value
                                })
                            });
                        return res
                    };

                    items.forEach((x) => {
                        x.flightClass.forEach((x2) => {
                            const rate = x2.secondLabel.split(' ').reverse()[0];
                            const label = x2.label;
                            // const cost = x2.value - currentCost;
                            const cost = getCost(label) - currentCost;
                            x2.secondLabel = `${cost > 0 ? '+' : ''} ${cost} ${rate}`;
                            x2.label = label;

                            if (!res.some(x3 => x3.label === label)) {
                                res.push({...x2})
                            }
                        });
                    });
                } else {
                    let currentCost = 0;

                    items = JSON.parse(JSON.stringify(items));
                    items.forEach((x, i) => {
                        if (i === items.length) return;
                        x.flightClass.forEach(x2 => {
                            if (parseInt(x2.secondLabel) === 0) {
                                currentCost += x2.value
                            }
                        });
                    });

                    items.forEach((x, i) => {
                        if (items.length === 1) {
                            x.flightClass.forEach((x2) => {
                                const rate = x2.secondLabel.split(' ').reverse()[0];
                                const cost = x2.value - currentCost;
                                const label = x2.label.split(" + ")[0];
                                x2.secondLabel = `${cost > 0 ? '+' : ''} ${cost} ${rate}`;
                                x2.label = label;
                                res.push({...x2})
                            })
                        } else {
                            if (i === items.length) return;

                            x.flightClass.forEach((x2) => {
                                let index = i + 1;
                                while(index < items.length) {
                                    items[index].flightClass.forEach(x3 => {
                                        const rate = x2.secondLabel.split(' ').reverse()[0];
                                        const cost = (x2.value + x3.value) - currentCost;
                                        const label = x2.label.split(" + ")[0];
                                        x2.secondLabel = `${cost > 0 ? '+' : ''} ${cost} ${rate}`;
                                        x2.label = label === x3.label ? label : label + " + " + x3.label;
                                        res.push({...x2})
                                    });
                                    index++;
                                }
                            });
                        }
                    });
                }

                return res
            },
            getFlightClassSelected(items) {
                const res = [];
                items.forEach(x => {
                    res.push(x.flightClassSelected)
                });
                return res
            },
            getFlightClassSelectedValue(items) {
                const res = [];
                items.forEach(x => {
                    res.push({value: x.flightClassSelectedValue, label: x.flightClassSelected.label})
                });
                return res
            },
            getFlightQuotaName(items) {
                let res = '';
                items.forEach(x => {
                    let quota = this.getQuotaName(x.flightClassSelected.allData.QuotaStatus);
                    if (this.getQuotaName(res) !== 'request' || this.getQuotaName(res) === 'less' && quota !== 'aviailable')
                        res = x.flightClassSelected.allData.QuotaStatus
                });

                return res
            },
            getFlightAirlinesTitle(items) {
                let res = '';
                items.forEach(x => {
                    const airline = x.allData.Airline.Value;
                    const departureAirport = x.allData.DepartureAirport.Key;
                    const arrivalAirport = x.allData.ArrivalAirport.Key;
                    const flight = x.allData.Flight.Value;
                    res += `${departureAirport} – ${arrivalAirport}, ${airline}, ${flight} \n`
                });

                return res
            },
            getFlightAirlines(items) {
                let res = '';
                items.forEach(x => {
                    const code = x.allData.Airline.Key;
                    res += res ? `, ${code}` : `(${code}`
                });

                return `${res})`
            },
            getFlightAirlineIds(items) {
                const result = new Set(items.map(x => x.allData.Airline.Id));
                return Array.from(result)
            },
            getFlightAiraport(items) {
                const arrival = items[items.length-1].allData.ArrivalAirport.Value;
                const arrivalCode = items[items.length-1].allData.ArrivalAirport.Key;
                const dep = items[0].allData.DepartureAirport.Value;
                const depCode = items[0].allData.DepartureAirport.Key;

                return `${dep} (${depCode}) – ${arrival} (${arrivalCode})`
            },
            getFlightTimeDuration(items) {
                let m = 0;
                let h = 0;
                let d = 0;
                items.forEach((x, i) => {
                    let flightTimeDiff = [0,0];
                    if (i % 2 === 0 && items[i + 1]) {
                        flightTimeDiff = this.$store.getters['calcTime'](x.timeTo, items[i + 1].timeFrom);
                    }
                    m += flightTimeDiff[1];
                    h += flightTimeDiff[0];

                    if (x.isGDS) {
                        m += this.correctTime(x.fligthTime)?.[1] || 0;
                        h += this.correctTime(x.fligthTime)?.[0] || 0;
                        // m += this.correctTime(x.fligthTime[x.key])?.[1] || 0;
                        // h += this.correctTime(x.fligthTime[x.key])?.[0] || 0;
                    } else {
                        m += x.timeDuration?.[1] || 0;
                        h += x.timeDuration?.[0] || 0;
                    }
                });
                if (m >= 60) {
                    h += Math.floor(m / 60);
                    m = m % 60
                }
                if (h >= 24) {
                    d += Math.floor(h / 24);
                    h = h % 24
                }
                return [d, h, m]
            },
            getDaysCount(date1, date2) {
                const from = moment(date1.allData.BeginDateTime.split("T")[0]);
                const to = moment(date2.allData.EndDateTime.split("T")[0]);
                const duration = moment.duration(to.diff(from));
                const days = duration.asDays();

                return Math.floor(days)
            },
            stop() {
                this.stopSelect = true
            },
            getFlightBeginDate(item) {
                let date = item.allData.BeginDateTime;
                return date.split("T")[0].split('-').reverse().join('.')
            },
            toCapitalize(str) {
                return str[0].toUpperCase() + str.slice(1).toLowerCase()
            },
            getTimeDuration(item) {
                let res = "";
                if (!item.timeDuration) return res;

                res = item.timeDuration[1] +" "+ this.localizeList.hourTextUpper +" "+ item.timeDuration[2] +" "+ this.localizeList.minutesTextUpper;
                if (item.timeDuration[0]) res = item.timeDuration[0] +" "+ this.localizeList.dayShort.slice(0,-1) +" "+ res;

                return res
            },
            getTimeLimit(item) {
                if (!item[0].timeLimit) return "";
                let time = getLocalTimeLimit(item[0].timeLimit).split(' ')[1];
                let date = getLocalTimeLimit(item[0].timeLimit).split(' ')[0];
                return `${date} ${time}`
            },
            getCurrencyDisplayBySettings(rate){
                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            correctTime(min) {
                if (!min) return null;

                const h = Math.floor(min/60);
                const m = min % 60;

                return [h, m]
            },
            correctPrice(val) {
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            changeFlight(key) {
                if (key === this.flightData.selected || this.stopSelect) {
                    this.stopSelect = false;
                    return
                }
                this.$emit("changeFlight", key)
            },
            changeFlightClass(key, key2, item) {
                // const notComboTariff = true;
                const notComboTariff = this.tour.LinkingFlightsRules.notCombineDifferentTariffGroupRule.enabled;

                if (notComboTariff) {
                    this.flight[key].forEach((x, i) => {
                        let flightClass = x.flightClass.find(x2 => x2.label === item[0].label);
                        let label = flightClass.label;
                        let cost = flightClass.value;
                        let value = [cost,label];

                        this.$emit("changeFlightClass", [key, i, value])
                    })
                } else {
                    let j = 0;
                    this.flight[key].forEach((x, i) => {
                        // if (key2 === 0 && x.flightType === 1 || key2 === 1 && x.flightType === 2) {
                        if (key2 === 0 && x.flightType === 1 || key2 === 1 && x.flightType !== 1) {
                            let label = item[j].label;
                            let cost = x.flightClass.find(x3 => x3.label === label).value;
                            let value = [cost, label];
                            j++;
                            this.$emit("changeFlightClass", [key, i, value])
                        }
                    })
                }
            },
            showDetails(item, isSubFlight = false) {
                if (isSubFlight) {
                    this.$emit("showDetails", this.flight[this.flightData.selected]);
                    return;
                }
                this.$emit("showDetails", item)
            },
            rightModalAviaFlight(item, isSubFlight = false) {
                if (isSubFlight) {
                    item = this.flight[this.flightData.selected]
                }
                this.$emit("rightModalAviaFlight", this.getFlight(item, false, false, true).flat(1))
            },
            toFlight() {
                this.$emit("toFlight")
            },
            resetFlight() {
                this.$emit("reset")
            },
            blockToggle() {
                this.$emit("toggle", !this.show)
            },
            tariffBlockToggle() {
                this.tariffBlockShow = !this.tariffBlockShow
            },
            getQuotaName(quota) {
                if (!quota) {
                    return null
                }
                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = "not-aviailable"
                } else if (quota.PlacesStatus === 4) {
                    res = "request"
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    res = "less"
                } else {
                    res = "aviailable"
                }
                return res
            },
            getQuotaText(quota) {
                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = this.localizeList.quotaHasNoPlaces
                } else if (quota.PlacesStatus === 4) {
                    res = this.localizeList.onRequest
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                    res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                } else {
                    res = this.localizeList.available
                }
                return res
            },
            getFlightCarryOnAndBaggage(items) {
                if (!items[0].isGDS) return;

                let res = {};
                items.forEach(x => {
                    res.carryOn = this.getLuggage(x.carryOnAndBaggage[0]);
                    res.baggage = this.getBigLuggage(x.carryOnAndBaggage[1]);
                    res.baggageType = this.getLuggageType(x.carryOnAndBaggage[1]);
                });

                return res
            },
            getLuggage(str) {
                let value = str.match(/\d+ к|\d+ k/);
                if (value) {
                    value = +value[0]?.[0] != 0 ? value[0].match(/\d+/)[0] : ""
                }
                let info = str;
                if (info === "HandLuggageOnly") {
                    info = this.localizeList.handOnly
                }

                return {
                    value: value || "",
                    info: info
                }
            },
            getBigLuggage(str) {
                let value = str.match(/\d+ к|\d+ k/);
                if (value) {
                    value = +value[0]?.[0] != 0 ? value[0].match(/\d+/)[0] : ""
                }
                let info = str;

                return {
                    value: value || "",
                    info: info
                }
            },
            getLuggageType(str) {
                let value = str;

                if (!value.match(/\d+/)) {
                    return 'big-luggage-question'
                }
                if (value.match(/\d+/)[0] == 0) {
                    return 'big-luggage-none'
                }
                if (!value.match(/\d+ к|\d+ k/)) {
                    return 'big-luggage-question'
                }
                if (value.match(/\d+/)[0] !== "0") {
                    return 'big-luggage'
                }
            },
            showPopover(text, e, preType = false) {
                let rect = e.target.getBoundingClientRect();
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height,
                    preType
                };
                this.$store.dispatch('A_SHOW_POPOVER', res);

                if (preType) {
                    document.querySelector('.popover-title').style.maxWidth = 'unset'
                } else {
                    document.querySelector('.popover-title').style.maxWidth = '320px'
                }
            },
            hidePopover() {
                this.$store.dispatch('A_HIDE_POPOVER');
                document.querySelector('.popover-title').style.maxWidth = '200px'
            }
        },
        filters: {
            capitalize(val) {
                return val.charAt(0).toUpperCase() + val.slice(1)
            }
        }
    }
</script>

<style scoped>
    .block {
        background: var(--white-color);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
        border-radius: 4px;
        margin-bottom: 12px;
        transition: all .3s;
    }

    .block .block-toggle-bar {
        border-radius: 4px;
        background: var(--primary-color);
        padding: 12px 16px;
        cursor: pointer;
    }

    .block.show .tariff-info.show .block-toggle-bar,
    .block.show .block-toggle-bar {
        border-radius: 4px 4px 0 0;
    }
    .block.show .tariff-info .block-toggle-bar {
        border-radius: 4px;
    }

    .block .block-toggle-bar .block-name span {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--white-color);
    }

    .block .block-toggle-bar .angle-icon {
        transform: rotate(0deg);
        transition: all .2s;
    }

    .block.show .tariff-info.show .block-toggle-bar .angle-icon,
    .block.show .block-toggle-bar .angle-icon {
        transform: rotate(180deg);
        transition: all .2s;
    }
    .block.show .tariff-info .block-toggle-bar .angle-icon {
        transform: rotate(0deg);
        transition: all .2s;
    }

    .basket .basket-content .flight-info-wrap {
        padding-bottom: 20px;
    }

    .basket .basket-content .block .change-btn {
        background: var(--primary-2-color);
        border: 1px solid #B2DBF8;
        box-sizing: border-box;
        border-radius: 20px;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--primary-color);
        padding: 10px 32px;
        transition: all .2s;
        outline: none;
        cursor: pointer;
    }

    .basket .basket-content .block .change-btn:hover {
        background: var(--primary-color);
        color: var(--white-color);
    }

    .basket .delta {
        font-weight: bold;
        font-size: 18px;
        /*line-height: 21px;*/
        color: #727272;
        /*margin-bottom: 11px;*/
        display: inline-block;
        line-height: 0;
    }

    .basket .flight-info-header {
        padding: 15px 30px 15px
    }

    .basket .flight-path {
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: #1D1D1D;
    }

    .basket .flight-info {
        padding: 0 28px;
        position: relative;
    }
    .basket .flight-info .delta {
        position: absolute;
        top: -8px;
    }
    /*.basket .flight-info:last-child {*/
    /*    padding-bottom: 30px;*/
    /*}*/

    .basket .flight-info .flight-headline {
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: #1D1D1D;
    }

    .basket .flight-info .flight-group {
        position: relative;
        background-color: var(--lighten-2-color);
        border-radius: 6px;
    }
    .basket .flight-info .flight-group.selected {
        border: 3px solid var(--primary-color);
        margin: -3px;
    }
    .basket .flight-info .flight-group.selected.single {
        border: none;
        margin: 0;
    }

    .basket .flight-info .flight-group .flight-coontent {
        display: flex;
        /*display: grid;*/
        align-items: center;
        justify-content: space-between;
        /*grid-template-columns: minmax(190px, auto) minmax(320px, auto) minmax(156px, auto) minmax(300px, auto);*/
        padding: 12px 16px 12px 12px;
    }

    .basket .flight-info .flight-group .flight-coontent:not(:last-child) {
        border-bottom: 1px solid #E0E0E0;
    }


    .basket .flight-info .flight-group .flight-coontent .date-avia-info {
        display: flex;
        /*display: grid;*/
        /*grid-template-columns: 270px auto;*/
    }
    .basket .flight-info .flight-group .flight-coontent .date-info {
        display: flex;
        /*align-items: center;*/
    }

    .basket .flight-info .flight-group .flight-coontent .date-info .day-info {
        width: 82px;
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--dark-1-color);
    }

    .basket .flight-info .flight-group .flight-coontent .date-info .time-info {
        max-width: 120px;
        min-width: 120px;
    }
    .basket .flight-info .flight-group .flight-coontent .date-info .time-info .time {
        font-weight: bold;
        font-size: 16px;
        line-height: 18px;
        color: var(--dark-1-color);
    }
    .basket .flight-info .flight-group .flight-coontent .date-info .time-info .time-diff {
        font-size: 13px;
        line-height: 20px;
        color: #727272;
    }

    .basket .flight-info .flight-group .flight-coontent .date-info .airlines-icon {
        position: relative;
        width: 26px;
        height: 26px;
    }
    .basket .flight-info .flight-group .flight-coontent .date-info .airlines-icon img {
        position: absolute;
        top: 0;
    }

    .basket .flight-info .flight-group .flight-coontent .avia-info .avia-code {
        font-size: 13px;
        line-height: 20px;
        color: var(--primary-color);
        max-width: 210px;
    }
    .basket .flight-info .flight-group .flight-coontent .avia-info .airline {
        font-size: 12px;
        line-height: 14px;
        color: #727272;
    }
    .basket .flight-info .flight-group .flight-coontent .details-info .popover-link {
        height: 16px;
    }

    .basket .flight-info .more-info-link {
        font-size: 15px;
        line-height: 18px;
        text-decoration-line: underline;
        color: var(--primary-color);
        cursor: pointer;
        transition: all .2s;
    }

    .basket .flight-info .more-info-link:hover {
        color: #55b4f9;
    }

    .basket .flight-info .flight-group .flight-coontent /deep/ .flight-class.flight-class-select {
        width: 280px;
    }

    .basket .flight-info .flight-group .flight-coontent /deep/ .flight-class.flight-class-select .select {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-right: 26px;
    }
    .basket .flight-info .flight-group .flight-coontent /deep/ .flight-class.flight-class-select .select span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .tariff-info-content {
        background-color: #f1f1f1;
        padding: 12px;
    }
    .tariff-info-content p {
        font-size: 13px;
        margin-left: 6px;
        font-weight: 200;
    }

    .luggage-text {
        font-weight: bold;
        font-size: 8px;
        line-height: 28px;
        color: var(--green-2-color);
    }

    .more-suggestions {
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: #727272;
        margin: 13px 0 25px;
        text-align: center;
    }

</style>
